import { memo } from "react";

import Typography from "@mui/material/Typography";

import { FindingType } from "stores/FindingStore";

import { getMarkdownAsReact } from "utility/markdown";

import Abstract from "./Abstract";

// -----------------------------------------------------------------------------

const OrganizationFindingDescriptionRow = memo(
  function OrganizationFindingDescriptionRow({
    findingType,
  }: OrganizationFindingDescriptionRowProps): JSX.Element {
    const description =
      findingType != null ? (
        getMarkdownAsReact(findingType.description.trim())
      ) : (
        <>
          Description not found. If you&apos;re seeing this, it usually means
          that we added this new finding type <em>just now</em>, as you were
          browsing the page! Feel free to refresh.
        </>
      );

    //
    return (
      <Abstract label="Description">
        <Typography
          variant="body1"
          component="div"
          sx={{ wordBreak: "break-word" }}
        >
          {description}
        </Typography>
      </Abstract>
    );
  }
);

export default OrganizationFindingDescriptionRow;

// -----------------------------------------------------------------------------

interface OrganizationFindingDescriptionRowProps {
  findingType?: FindingType;
}
